import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./AutoScallingyad2taxiforsale.css";

const carBrands = [
  "dacia", "ford", "hyundai", "kia", "mercedes", "mitsubishi",
  "peugeot", "renault", "skoda", "toyota", "volkswagen"
];

// מיפוי שמות באנגלית -> עברית
const brandMap = {
  dacia: "דאצ'יה",
  ford: "פורד",
  hyundai: "יונדאי",
  kia: "קיה",
  mercedes: "מרצדס",
  mitsubishi: "מיצובישי",
  peugeot: "פיג'ו",
  renault: "רנו",
  skoda: "סקודה",
  toyota: "טויוטה",
  volkswagen: "פולקסווגן"
};

const AutoScallingyad2taxiforsale = () => {
  const containerRef = useRef(null);
  const navigate = useNavigate();
  let startX = 0;
  let scrollLeft = 0;

  const handleTouchStart = (e) => {
    startX = e.touches[0].pageX - containerRef.current.offsetLeft;
    scrollLeft = containerRef.current.scrollLeft;
  };

  const handleTouchMove = (e) => {
    e.preventDefault();
    const x = e.touches[0].pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleBrandClick = (brand) => {
    const hebrewBrand = brandMap[brand];
    if (hebrewBrand) {
      const encodedBrand = encodeURIComponent(hebrewBrand);
      navigate(`/AllTaxiYad2ForSalepage?manufacturer=${encodedBrand}`);
    }
  };

  return (
    <div
      className="scrolling-wrapper"
      ref={containerRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
    >
      <div className="scrolling-track">
        <div className="scrolling-icons">
          {[...carBrands, ...carBrands].map((brand, index) => (
            <img
              key={index}
              src={`/public/icons/${brand}.png`}
              alt={`${brand} logo`}
              className="scrolling-icon"
              onClick={() => handleBrandClick(brand)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AutoScallingyad2taxiforsale;
